import { faThermometerQuarter } from '@fortawesome/free-solid-svg-icons'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: false,
  addCarPh : false ,
  carType : '4x4',
  announcer : ""
}

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {


    /** Reservation procedure ***/


    reserve: state => {
      state.resv = !state.resv;
    },
    payMeth: state => {
      state.payMeth = !state.payMeth
    },
    viaPay: state => {
      state.viaPay = !state.viaPay
    },
    contactPay: state => {
      state.contactPay = !state.contactPay
    },
    baridiPay: (state) => {
      state.baridi = !state.baridi;
    },


    /**Authentication  ***/

    logIn: (state) => {
      state.login = !state.login
    },
    signUp: (state) => {
      state.sign = !state.sign
    },
    signupPro: (state) => {
      state.signPro = !state.signPro
    },


    /**Add Announce ***/

    addAnn: (state) => {
      state.addAnn = !state.addAnn
    },
    addHeberg: (state) => {
      state.addHeberg = !state.addHeberg
    },
    addPhotoHeberg: (state) => {
      state.addPhoto = !state.addPhoto
    },
    addAgendaHeberg: (state) =>{
      state.addAgendaHeberg=!state.addAgendaHeberg
    },
    addCarPhotos: (state) => {
      state.addCarPh = !state.addCarPh
    },
    addCar: (state,action) => {
      state.carType = action.payload
      state.addCar = !state.addCar
    },
    addTransfert: (state) => {
      state.addTransfert = !state.addTransfert
    },
    addVol: (state) => {
      state.addVol = !state.addVol
    },
    addVoyage: (state) => {
      state.addVoyage= !state.addVoyage
    },
    addTarifVoyage: (state) => {
      state.addTarifVoyage= !state.addTarifVoyage
    },
    addPhotoVoyage: (state ) => {
      state.addPhotoVoyage= !state.addPhotoVoyage
    },
    addVisa: (state ) => {
      state.addVisa= !state.addVisa
    },

    /** New message */

    newMessage: (state,action) => {
      state.newMessage = !state.newMessage
      state.announcer = action.payload
    },


  },
})


export const { reserve, payMeth, baridiPay, viaPay, contactPay, signUp, logIn, signupPro, addAnn,addCarPhotos, addHeberg, addPhotoHeberg, addCar, newMessage, addVol,addVoyage,addTarifVoyage,addPhotoVoyage,addTransfert,addVisa,addAgendaHeberg } = modalSlice.actions

export default modalSlice.reducer